import Sentry from '@/services/sentry'
import { getWithExpiry, setWithExpiry, DAY_IN_MILLISECONDS } from '@/utils/local.storage.expiry'

const KEY_PREFIX = 'create-slide-popup-recently-used-section'
const MAX_ITEMS = 4
const EXPIRY_TTL = DAY_IN_MILLISECONDS * 30 // 30 days

const getStorageKey = (userId) => `${KEY_PREFIX}-${userId}`

export const getRecentlyUsedSlides = (userId) => {
  if (!userId) return []
  try {
    const key = getStorageKey(userId)
    const stored = getWithExpiry(key)
    if (Array.isArray(stored)) {
      return stored.slice(0, MAX_ITEMS)
    }
    return []
  } catch (error) {
    // Fail silently
    return []
  }
}

export const updateRecentlyUsedSlides = (userId, slideName) => {
  if (!userId || !slideName) return getRecentlyUsedSlides(userId)
  try {
    const key = getStorageKey(userId)
    let currentList = getRecentlyUsedSlides(userId)

    // Remove if exists to move to top (no duplicates)
    currentList = currentList.filter((name) => name !== slideName)

    // Add to front (Most recent)
    currentList.unshift(slideName)

    // Limit to MAX_ITEMS
    if (currentList.length > MAX_ITEMS) {
      currentList = currentList.slice(0, MAX_ITEMS)
    }

    setWithExpiry(key, currentList, EXPIRY_TTL)
    return currentList
  } catch (error) {
    Sentry.captureException(error, {
      tags: {
        feature: 'create-slide-popup-recently-used-section',
        context: 'updateRecentlyUsedSlides',
      },
    })
    return getRecentlyUsedSlides(userId)
  }
}
